(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@draftkings/player-page", [], factory);
	else if(typeof exports === 'object')
		exports["@draftkings/player-page"] = factory();
	else
		root["@draftkings/player-page"] = factory();
})(self, function() {
return 